/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(isSameOrBefore);

const validationInformationsDeclarationConvention = (
    data: any,
    selectedDeclarationType?: string | null,
) => {
    const errors = {
        dateConventionInitiale: '',
        attestationLienParente: '',
        attestationResidenceCommune: '',
        adresseCommune: '',
        dateDeclarationInitiale: '',
        libelleCommuneDelegueCommune: '',
        libelleCommuneDelegueDeclaration: '',
        libelleCommuneDelegueConvention: '',
    };

    const {
        dateDeclaration,
        dateConvention,
        attestationLienParente,
        attestationAdresseCommune,
        adresseCommune,
        adresseDeclaration,
        adresseConvention,
    } = data?.conventionDeclaration

    // Dates convention et déclaration : facultatives pour un projet, mais
    // jamais dans le futur quand elles sont saisies
    const champsObligatoires = selectedDeclarationType !== 'projet';

    if (!dateDeclaration) {
        if (champsObligatoires) {
            errors.dateDeclarationInitiale = 'La date de convention initiale est obligatoire';
        }
    } else if (!dayjs(dateDeclaration).isSameOrBefore(dayjs(), 'day')) {
        errors.dateDeclarationInitiale = 'La date de convention initiale doit être antérieure ou égale à la date du jour';
    }
    if (!dateConvention) {
        if (champsObligatoires) {
            errors.dateConventionInitiale = 'La date de convention initiale est obligatoire';
        }
    } else if (!dayjs(dateConvention).isSameOrBefore(dayjs(), 'day')) {
        errors.dateConventionInitiale = 'La date de convention initiale doit être antérieure ou égale à la date du jour';
    }

    // Attestations et adresse commune : facultatives pour un projet
    if (champsObligatoires) {
        if (!attestationLienParente) {
            errors.attestationLienParente = 'L’attestation de lien de parenté est obligatoire';
        }

        if (!attestationAdresseCommune) {
            errors.attestationResidenceCommune = 'L’attestation de résidence commune est obligatoire';
        }

        if (!adresseCommune?.libelleVoie) {
            errors.adresseCommune = 'La voie de la résidence commune est obligatoire';
        }

        if (!adresseCommune?.codePostal) {
            errors.adresseCommune = 'Le code postal de la résidence commune est obligatoire';
        }

        if (!adresseCommune?.localite) {
            errors.adresseCommune = 'La localité de la résidence commune est obligatoire';
        }
    }

    // Communes déléguées : le libellé est obligatoire dès que la case correspondante est cochée
    if (adresseCommune?.communeDelegue && _.isEmpty(_.trim(adresseCommune?.libelleCommuneDelegue))) {
        errors.libelleCommuneDelegueCommune = 'Le libellé de la commune déléguée est obligatoire';
    }

    if (adresseDeclaration?.communeDelegue && _.isEmpty(_.trim(adresseDeclaration?.libelleCommuneDelegue))) {
        errors.libelleCommuneDelegueDeclaration = 'Le libellé de la commune déléguée est obligatoire';
    }

    if (adresseConvention?.communeDelegue && _.isEmpty(_.trim(adresseConvention?.libelleCommuneDelegue))) {
        errors.libelleCommuneDelegueConvention = 'Le libellé de la commune déléguée est obligatoire';
    }

    return _.pickBy(errors, (value) => value !== '');
};

export default validationInformationsDeclarationConvention;
